var spinnerInit = function () {

    var spinnerDiv = $('[data-id="spinner"]'),
        spinnerDelay = 0,
        spinnerTimer = null,
        announcementDiv = $("#spinnerAnnouncement");

    function showSpinner() {
        spinnerTimer = setTimeout(function () {
            spinnerDiv.queue(function () {
                $(this)
                .addClass('js-active')
                    .clearQueue();
                announcementDiv.text("");
                setTimeout(function () {
                    announcementDiv.text("Processing request");
                }, 50);
            });

        }, spinnerDelay);

    }

    function hideSpinner() {
        clearTimeout(spinnerTimer);
        //spinner needs to be hidden on last xhr during simultaneous xhr's
        if (jQuery.active === 1) {
            spinnerDiv.removeClass("js-active");
            announcementDiv.text("");
        }
    }

    //on asynchronous request to server
    $(document).on("ajaxSend", function (e, jqxhr, settings) {
        var uploadURL = islington.url.uploadDocument,
            isUpload = (uploadURL == settings.url.split('?')[0]) ? true : false;
        if(!isUpload)
            showSpinner();
    }).on("ajaxComplete", function (e, res, options) {
        var eventActivator = e.currentTarget.activeElement,
        hasResponseError = false,
        isElementWithBothAjaxPost =
        $(eventActivator).hasClass('requestajaxwithpost');

        if (res.responseJSON != undefined) {
            hasResponseError = ((res.responseJSON.Errors != null) &&
            (res.responseJSON.Errors !== undefined)) || (res.responseJSON.LoginSuccess != true) ;
        }

        if (!isElementWithBothAjaxPost || hasResponseError) {
            hideSpinner();
        }
    }).on('ajaxError',function(){
        hideSpinner();
    });

    //on normal form submission
    $("form").on("submit", function (e) {
        if (!e.isDefaultPrevented())
            showSpinner();
    });
};



